import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import Zendesk from '@dansmaculotte/vue-zendesk'

/*import VueGtag from "vue-gtag";*/
import VueAnalytics from 'vue-analytics'



/*Vue.use(VueGtag, {
  config: { id: "UA-157856459-32" }
});*/

Vue.use(VueAnalytics, {
  id: ' UA-157856459-22',
  router,
  linkers: ['www.veeambooth.com', 'www.veeamlive.com/agenda', 'www.veeamlive.com/community']
})

Vue.use(Zendesk, {
  key: 'Y324c4ae4-96e0-40e8-aca5-47645f5163a7',
  disabled: false,
  hideOnLoad: true,
  settings: {
    webWidget: {
      color: {
        theme: '#005F4B'
      }
    }
  }
})


import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)



Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

